import type { CategoriaComContrato, EstadoCriacao } from '@/features/contracts';

import type { DestinoCriacaoSidebar, GateCriacaoSidebar } from '../types';

const LISTA_ARBITRAL = '/arbitral';

/**
 * Atalho de criação arbitral da Sidebar. Decide pelo mesmo `EstadoCriacao` que a lista e a
 * revisão usam, para a regra não ter uma segunda cópia que diverge. Enquanto o contrato carrega,
 * segue para a criação (a própria tela barra no envio). Qualquer bloqueio, inclusive o erro ao
 * verificar o plano, cai na lista, onde a mensagem aparece.
 */
export function destinoDaCriacaoArbitral(estado: EstadoCriacao, path: string): string {
  return estado === 'LIVRE' || estado === 'CARREGANDO' ? path : LISTA_ARBITRAL;
}

/**
 * Atalho de criação de Notificação e Negociação. Fica com os gates próprios da Sidebar porque
 * a ordem dela não é a do `resolverEstadoCriacao`: Notificação no limite abre o modal de cota
 * mesmo com o trial bloqueado, e "tem contrato" aqui é `hasActive` sem o trial expirado à parte.
 * Migrar mudaria o comportamento das duas categorias, que a A-23 não alcança: a ordem da
 * Notificação no `EstadoCriacao` tem de ser escolhida com o produto antes.
 *
 * O erro é termo explícito porque o slice mantém o contrato antigo quando a nova leitura
 * falha: sem ele, um contrato velho liberaria a criação.
 */
export function destinoDaCriacao(
  categoria: Exclude<CategoriaComContrato, 'ARBITRAGEM'>,
  gate: GateCriacaoSidebar,
  path: string,
): DestinoCriacaoSidebar {
  const { resolvido, erro, hasContract, atLimit, blocked, listPath } = gate;

  if (!resolvido) return { tipo: 'navegar', path };
  if (erro) return { tipo: 'navegar', path: listPath };
  if (atLimit && categoria === 'NOTIFICACAO') return { tipo: 'modalCota' };
  if (!hasContract || blocked || atLimit) return { tipo: 'navegar', path: listPath };
  return { tipo: 'navegar', path };
}
